var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.createAfterTableData.length !== 0)?_c('h5',[_vm._v(" "+_vm._s(_vm.$t('key1004781'))+_vm._s(_vm.createAfterTableData.length)+_vm._s(_vm.$t('key1004782'))+" ")]):_vm._e(),_c('Table',{attrs:{"border":"","columns":_vm.columns,"data":_vm.createAfterTableData}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }